<template>
    <div class="AdminImport">
        <FadeTransition mode="out-in">
            <div
                class="AdminImportHeader flex row-stretch-center"
                :class="{ 'Separate': store.buttons || breadcrumbs}"
            >
                <Breadcrumbs :breadcrumbs="breadcrumbs" v-if="'AdminImportsValidate' !== routeName"/>
				<div v-else><h4>Records Manual Validations</h4></div>
                <div
                    v-if="store.buttons && 'AdminImportsValidate' !== routeName"
                    class="flex"
                >
                    <Reload v-if="store.reload" />
                    <WButton
                        v-for="({ text, disabled, onClick, ...otherProps }, index) in store.buttons"
                        :key="index"
                        :disabled="disabled"
                        v-bind="otherProps"
                        class="ml-1"
                        @click="onClick"
                    >
                        {{ text }}
                    </WButton>
                </div>
            </div>
        </FadeTransition>
        <Transition
            name="main-router"
            mode="out-in"
        >
            <RouterView />
        </Transition>
    </div>
</template>

<script>
import { Breadcrumbs, Reload } from '@/components'

export default {
    name: 'AdminImportsScreen',
    components: {
        Breadcrumbs,
        Reload,
    },
    provide () {
        return {
            Entity: this,
        }
    },
    data () {
        return {
            store: {}
        }
    },
    computed: {
		routeName(){
			return this.$route.name;
		},
        breadcrumbs () {
            const { breadcrumbs } = this.store

            return [
                {
                    key: 'AdminImports',
                    label: this.$t('imports.title'),
                    to: { name: 'AdminImports' },
                },
                ...(breadcrumbs || ((this.$route.meta || {}).breadcrumb ? [{
                    key: this.$route.name,
                    label: this.$route.meta.breadcrumb,
                    to: { name: this.$route.name },
                }] : [])),
            ]
        },
    },
}
</script>

<style lang="scss" scoped>
.AdminImportHeader{
    &.Separate {
        margin-bottom: 20px;
    }
}
</style>
